// Stub: NFLDemoSabotageModal (file lost during git history cleanup)
interface Props {
  cards: any[];
  onClose: () => void;
  onSignUp: () => void;
}
export default function NFLDemoSabotageModal({ cards, onClose, onSignUp }: Props) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center" onClick={onClose}>
      <div className="bg-[#222] rounded-xl p-6 max-w-sm text-center" onClick={e => e.stopPropagation()}>
        <h3 className="text-xl font-bold text-white mb-2">Sabotage!</h3>
        <p className="text-gray-400 mb-4">{cards.length} sabotage cards available</p>
        <button onClick={onSignUp} className="bg-[#FD864D] text-white px-6 py-2 rounded-lg font-bold">
          Sign Up to Play
        </button>
      </div>
    </div>
  );
}
